import { createLoader, parseAsArrayOf, parseAsStringEnum } from 'nuqs/server';

enum NumberOfRooms {
  one = '1',
  two = '2',
  three = '3',
  four = '4',
  fivePlus = '5,6,7,8,9,10',
}

const keyMaps = {
  rooms: parseAsArrayOf(parseAsStringEnum(Object.values(NumberOfRooms))),
};

const urlKeys = {
  rooms: 'rooms',
};
const roomLoader = createLoader(keyMaps, { urlKeys });

export { keyMaps, NumberOfRooms, roomLoader, urlKeys };
